import * as types from '@store/types'
import request from '@queries'
import PartnersNearby from '@queries/PartnersNearby'

const state = {
  partnersNearby: []
}

const getters = {
  [types.PARTNERS_NEARBY]: ({ partnersNearby }) => partnersNearby,
  [types.SHELF_PARTNERS_NEARBY]: ({ partnersNearby }) => {
    return {
      name: 'Próximos a você',
      icon: 'pin-location',
      route: {
        name: 'Próximos a você',
        params: {},
        path: '/proximos-a-voce/'
      },
      campaigns: partnersNearby && partnersNearby.map(
        (campaign) => ({
          ...campaign,
          isPartner: false,
          isNextToYou: true
        })
      )
    }
  }
}

const mutations = {
  [types.PARTNERS_NEARBY]: (state, payload) => {
    state.partnersNearby = payload
  }
}

const actions = {
  [types.USER_LOCATION]: async ({ commit }) => {
    let lat, lng
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        lat = position.coords.latitude
        lng = position.coords.longitude

        request(PartnersNearby, { lat: String(lat), lng: String(lng) })
          .then(res => {
            commit(types.PARTNERS_NEARBY, res.data.data.partnersNearby)
          })
      })
    }
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/geolocation.js